'use client'

import { motion } from 'framer-motion'
import { ArrowRight } from 'lucide-react'
import Link from 'next/link'
import { useSession } from 'next-auth/react'
import posthog from 'posthog-js'
import type { ComponentProps, ReactNode } from 'react'

import { RainbowButton } from '@client/components/ui/rainbow-button'
import { useCredits } from '@client/providers/credits-provider'

/** Keep animation and click handling in client islands; marketing copy stays server-rendered. */
export function MarketingMotion(props: ComponentProps<typeof motion.div>) {
  return <motion.div {...props} />
}

export function MarketingLink({
  href,
  kind,
  location,
  children,
  className,
}: {
  href: string
  kind: 'submit' | 'publisher'
  location: string
  children: ReactNode
  className?: string
}) {
  const { data: session } = useSession()
  const { credits } = useCredits()
  return (
    <Link
      href={href}
      className={className}
      onClick={() => {
        if (window.location.hostname.includes('localhost')) return
        if (kind === 'submit')
          posthog.capture('submit_manuscript_clicked', {
            location,
            hasJournalAccess: session?.user?.hasJournalAccess === true,
            isPremium: credits?.total === null,
          })
        else if (href.startsWith('mailto:')) posthog.capture('publisher_pilot_clicked', { location })
      }}
    >
      {children}
    </Link>
  )
}

export function ReviewCTA() {
  const { data: session } = useSession()
  const { credits } = useCredits()
  const label =
    session?.user?.hasJournalAccess === true
      ? 'Journal Upload'
      : credits?.total === null
        ? 'Premium Upload'
        : 'Start Your Review'
  return (
    <RainbowButton size="lg" className="text-base px-8 py-6 rounded" asChild>
      <MarketingLink href="/upload" kind="submit" location="hero">
        {label}
        <ArrowRight className="ml-2 h-5 w-5" />
      </MarketingLink>
    </RainbowButton>
  )
}
